import { NetworkStorageParams, UseSideNavUserData } from '../../../../common/types';
import { useLocalSideNavUserData } from '../use-local-side-nav-user-data';
import { useNetworkSideNavUserData } from '../use-network-side-nav-user-data';

import { UseSideNavUserDataParams } from './types';

export function useSideNavUserData(params: UseSideNavUserDataParams): UseSideNavUserData {
	const { customizationStore, networkStorageParams } = params;

	if (
		customizationStore === 'network' &&
		!(
			networkStorageParams?.entityAri &&
			networkStorageParams?.ownerAri &&
			networkStorageParams?.queryRef
		)
	) {
		throw new Error(
			'Attempted to use network storage for the GlobalSideNavigation but there were missing networkStorageParam values',
		);
	}

	const hook = customizationStore === 'local' ? useLocalSideNavUserData : useNetworkSideNavUserData;
	return hook(networkStorageParams as NetworkStorageParams);
}
